import { Column } from "@shared/primitive-components"
import { StatusCell } from "."
import { TableEntry } from "../../types"
import { EntryPropertyCell } from "./EntryPropertyCell"

export const columns: ReadonlyArray<Column<TableEntry>> = [
  { Header: `Registration Number`, accessor: `registrationNumber` },
  {
    Header: `Make`,
    accessor: `make`,
    Cell: EntryPropertyCell,
  },
  {
    Header: `Model`,
    accessor: `model`,
    Cell: EntryPropertyCell,
  },
  {
    Header: `Fuel`,
    accessor: `fuelType`,
    Cell: EntryPropertyCell,
  },
  {
    Header: `Status`,
    Cell: StatusCell,
  },
]
